import {ContactLabel} from "./Address";
import ic_phone from "../assets/icon/ic_phone.svg";
import ic_mail from "../assets/icon/ic_mail.svg";
import {useTranslation} from "react-i18next";
import {Dialog, DialogBackdrop, DialogPanel} from '@headlessui/react'

export default function ContactDialog(props) {
    const {t} = useTranslation();

    return (
        <Dialog open={props.open} onClose={props.onClose} className="relative z-50">
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-black/50 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full justify-center p-4 text-center items-center">
                    <DialogPanel transition
                        className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl
                        p-6
                        transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0
                        data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in
                        max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                    >
                        <div className="bg-white min-w-96">
                            <div className="flex items-start">
                                <div className="text-left">
                                    <h3 className="text-base font-normal mb-4">{t("contact_dialog_title")}</h3>
                                    <div className="flex flex-col gap-2 mt-4 font-bold">
                                        <ContactLabel icon={ic_phone} name="+6663-190-7455" fontSize="text-base"/>
                                        <ContactLabel icon={ic_mail} name="info@siamcottonwool.co.th" fontSize="text-base"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="text-right mt-4">
                            <button type="button" onClick={props.onClose}
                                    className="py-2.5 px-5 text-base font-bold text-white bg-primary rounded">
                                {t("contact_dialog_button")}
                            </button>
                        </div>
                    </DialogPanel>
                </div>
            </div>
        </Dialog>
    )
}
